import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { checkVAT, countries } from 'jsvat';

const validatableCountries = (countries as any).flatMap(country => country.codes[0]);

export function vatCountryFormatValidator(country: string, translate: TranslateService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let vat = control.value?.toString().replace(/[\s-]/g, ''); // Normalize VAT input

    if (!vat) {
      return null; // No input, so valid by default (let other validators handle required)
    }

    if (country === 'us') {
      return null;
    }

    // if the number starts with a country code that is not portugal or spain, and is not just numbers, use the default validator
    if (!vat.startsWith('PT') && !vat.startsWith('ES') && !/^\d+$/.test(vat)) {
      // Extract the country code from the VAT number
      const countryCodeMatch = vat.match(/^[A-Za-z]{2}/);
      const countryCode = countryCodeMatch ? countryCodeMatch[0].toUpperCase() : '';

      // If the country code is not in validatableCountries, return null
      if (!validatableCountries.includes(countryCode)) {
        return null;
      }

      const valid = checkVAT(vat, countries);

      return valid?.isValid
        ? null
        : { vatInvalid: { message: translate.instant('SHARED.paymentModal.vatNumberInvalid', { value: valid?.country?.isoCode?.short || country.toUpperCase() }) } };
    }

    switch (country) {
      case 'pt':
        // Remove "PT" prefix if present
        if (vat.startsWith('PT')) vat = vat.slice(2);

        // Validate using checkVAT for Portugal
        const validPT = checkVAT(`PT${vat}`, countries);
        return validPT?.isValid ? null : { vatInvalid: { message: translate.instant('GENERAL.validators.invalidPortugueseVat') } };

      case 'es':
        // Remove "ES" prefix if present
        if (vat.startsWith('ES')) vat = vat.slice(2);

        // Validate using checkVAT for Spain
        const validES = checkVAT(`ES${vat}`, countries);
        return validES?.isValid ? null : { vatInvalid: { message: translate.instant('GENERAL.validators.invalidSpanishVat') } };

      default:
        // Other countries: consider valid by default
        return null;
    }
  };
}
